const STORAGE_KEY = "threedc_api_targets";
const LEGACY_TEST_URL = "https://dev2.4pay.ca/lab/3dc-consumer/api";
const PORTAL_TEST_URL = "https://dev2.4pay.ca/portal/www/3D/consumer/api";

const defaults = () => ({
  environment: "test",
  local: "http://127.0.0.1:8094/api",
  test: PORTAL_TEST_URL,
  production: "https://dev2.4pay.ca/3dc-consumer/api",
});

const cleanUrl = (value) => String(value || "").trim().replace(/\/+$/, "");

export const getThreeDCTargets = () => {
  const fallback = defaults();
  try {
    const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
    const targets = {
      ...fallback,
      ...saved,
      local: cleanUrl(saved.local || fallback.local),
      test: cleanUrl(saved.test || fallback.test),
      production: cleanUrl(saved.production || fallback.production),
    };
    if (targets.test === LEGACY_TEST_URL) {
      targets.test = PORTAL_TEST_URL;
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(targets));
      if (targets.environment === "test") {
        window.localStorage.setItem("3dc.apiBase", PORTAL_TEST_URL);
      }
    }
    return targets;
  } catch {
    return fallback;
  }
};

export const saveThreeDCTargets = (targets) => {
  const fallback = defaults();
  const normalized = {
    environment: ["local", "test", "production"].includes(targets.environment)
      ? targets.environment
      : fallback.environment,
    local: cleanUrl(targets.local || fallback.local),
    test: cleanUrl(targets.test || fallback.test),
    production: cleanUrl(targets.production || fallback.production),
  };

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  window.localStorage.setItem("3dc.apiBase", normalized[normalized.environment]);
  window.dispatchEvent(new CustomEvent("threedc-target-changed", { detail: normalized }));
  return normalized;
};

export const getThreeDCBase = (providedTargets) => {
  const targets = providedTargets || getThreeDCTargets();
  const base = targets[targets.environment] || targets.test;
  if (window.localStorage.getItem("3dc.apiBase") !== base) {
    window.localStorage.setItem("3dc.apiBase", base);
  }
  return base;
};
